import React, { useState, useEffect, useRef } from "react";
import ReactTable from "react-table";
import Button from "components/button/Button";
import Pagination from "components/common/Pagination";
import "react-table/react-table.css";
import { withRouter } from "react-router";
import StaticPageServices from "../../api/StaticpageServices";
import Loader from "../common/Loader";
// import CommonModel from "../common/CommonModel";
// import DeleteModal from "../common/DeleteModal";
//import Moment from "react-moment";
import Toaster from "../common/Toaster";
import {
  MODULE_NAMES,
  PERMISSION_TYPE,
  TABLE,
  SERVICE_TYPE,
  SERVICE_NAME
} from "../../helper/constant";
import EncryptDecrypt from "../../api/EncryptDecrypt";
import { hasAccess } from "util/sidebar";
import CommonModel from "components/common/CommonModel";
import DeleteModal from "components/common/DeleteModal";
import {
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu
} from "reactstrap";

const StaticPageTable = props => {
  const { permissions } = props;
  const [tblData, settblData] = useState();
  const [loader, setLoader] = useState(false);
  const [pages, setPages] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [field, setField] = useState("created_at");
  const [sortBy, setSortBy] = useState("DESC");
  const [templateField, setTemplateField] = useState("title");
  const [templateSortBy, setTemplateSortBy] = useState("ASC");

  const [visitNotesTblData, setVisitNotesTblData] = useState();
  const [id, setId] = useState(undefined);
  const [modal, setModal] = useState(undefined);
  const [visitNoteLoader, setVisitNoteLoader] = useState(false);
  const [searchTemplateText, setSearchTemplateText] = useState("");

  // Service filter states
  const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState(null);
  const [selectedServiceName, setSelectedServiceName] = useState(
    "All Services"
  );

  const toaster = useRef();

  useEffect(() => {
    getList(field, sortBy, searchText, activePage + 1);
    setPages(10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    hasAccess(
      MODULE_NAMES.VISIT_NOTE_TEMPLATE,
      PERMISSION_TYPE.VIEW,
      permissions
    ) &&
      getVisitNotesList(
        templateField,
        templateSortBy,
        searchTemplateText,
        activePage + 1
      );
    setPages(10);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Refetch visit notes when service filter changes
  useEffect(() => {
    if (
      hasAccess(
        MODULE_NAMES.VISIT_NOTE_TEMPLATE,
        PERMISSION_TYPE.VIEW,
        permissions
      )
    ) {
      getVisitNotesList(templateField, templateSortBy, searchTemplateText, 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedServiceId]);

  const deleteClick = data => {
    setId(data.id);
    setModal(true);
  };

  function deleteHandler() {
    setVisitNoteLoader(true);
    const params = {
      id: id
    };
    StaticPageServices.deleteVisitNoteTemplate(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          if (toaster.current) toaster.current.success(data.message);
          setVisitNoteLoader(false);
          setModal(false);
          setTimeout(() => {
            getVisitNotesList(
              templateField,
              templateSortBy,
              searchTemplateText,
              activePage + 1,
              1
            );
          }, 1000);
        } else {
          if (toaster.current) toaster.current.error(data.message);
          setVisitNoteLoader(false);
          setModal(false);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.message);
        setVisitNoteLoader(false);
        setModal(false);
      });
  }

  function toggle() {
    setModal(false);
  }

  const toggleServiceDropdown = () =>
    setServiceDropdownOpen(prevState => !prevState);

  const columns = [
    {
      Header: "Title",
      accessor: "title",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      sortable: true
    },
    {
      Header: "Action",
      accessor: "action",
      className: "",
      headerClassName: "react-table-header-class",
      sortable: false,
      filterable: false,

      Cell: props => (
        <div className="react-action-class">
          {hasAccess(
            MODULE_NAMES.STATIC_PAGE,
            PERMISSION_TYPE.VIEW,
            permissions
          ) ? (
            <Button
              className="c-btn c-info mr-10"
              onClick={() => formAction("view", props.original)}
            >
              <div className="fs-14 medium-text" title="View">
                <i className="fas fa-eye" />
              </div>
            </Button>
          ) : null}
          {hasAccess(
            MODULE_NAMES.STATIC_PAGE,
            PERMISSION_TYPE.EDIT,
            permissions
          ) ? (
            <Button
              className="c-btn c-success mr-10"
              onClick={() => formAction("edit", props.original)}
            >
              <div className="fs-14 medium-text">
                <i className="fas fa-edit" />
              </div>
            </Button>
          ) : null}
          {/* <Button
            className="c-btn c-danger"
            onClick={() => deleteClick(props.original)}
          >
            <div className="fs-14 medium-text">
              <i className="fas fa-trash mr-6" /> Delete
            </div>
          </Button> */}
        </div>
      ) // Custom cell components!
    }
  ];

  const visitNotesColumn = [
    {
      Header: "Title",
      accessor: "title",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      sortable: true
    },
    {
      Header: "Service",
      accessor: "service.name",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class",
      sortable: false
    },
    {
      Header: "Action",
      accessor: "action",
      className: "",
      headerClassName: "react-table-header-class",
      sortable: false,
      filterable: false,

      Cell: props => (
        <div className="react-action-class">
          {hasAccess(
            MODULE_NAMES.VISIT_NOTE_TEMPLATE,
            PERMISSION_TYPE.VIEW,
            permissions
          ) ? (
            <Button
              className="c-btn c-info mr-10"
              onClick={() => formActionForNotes("view", props.original)}
            >
              <div className="fs-14 medium-text" title="View">
                <i className="fas fa-eye" />
              </div>
            </Button>
          ) : null}
          {hasAccess(
            MODULE_NAMES.VISIT_NOTE_TEMPLATE,
            PERMISSION_TYPE.EDIT,
            permissions
          ) ? (
            <Button
              className="c-btn c-success mr-10"
              onClick={() => formActionForNotes("edit", props.original)}
            >
              <div className="fs-14 medium-text">
                <i className="fas fa-edit" />
              </div>
            </Button>
          ) : null}
          {hasAccess(
            MODULE_NAMES.VISIT_NOTE_TEMPLATE,
            PERMISSION_TYPE.DELETE,
            permissions
          ) ? (
            <Button
              className="c-btn c-danger"
              onClick={() => deleteClick(props.original)}
            >
              <div className="fs-14 medium-text">
                <i className="fas fa-trash mr-6" /> Delete
              </div>
            </Button>
          ) : null}
        </div>
      ) // Custom cell components!
    }
  ];

  const onChangePageGetData = state => {
    if (state.page !== activePage) {
      // alert("on page change you have to call api and get data");
    }
  };

  const formAction = (action, data = null) => {
    // Here you can view the data and make forward action for edit data
    if (action === "add") {
      props.history.push("/static-page/add");
    } else if (action === "edit") {
      props.history.push(`/static-page/edit/${data.id}`, { ...data });
    } else if (action === "view") {
      props.history.push(`/static-page/view/${data.id}`, { ...data });
    }
  };

  const formActionForNotes = (action, data = null) => {
    // Here you can view the data and make forward action for edit data
    if (action === "add") {
      props.history.push("/visit-note-template/add");
    } else if (action === "edit") {
      props.history.push(`/visit-note-template/edit/${data.id}`, { ...data });
    } else if (action === "view") {
      props.history.push(`/visit-note-template/get/${data.id}`, { ...data });
    }
  };

  function getList(field = "title", sortBy = "DESC", search = "", page = "1") {
    const params = {
      sort_by: field,
      order: sortBy,
      search: search,
      page: page
    };
    setLoader(true);
    StaticPageServices.list(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          settblData([...data.data.rows]);
          setPages(Math.ceil(data.data.count / TABLE.LIMIT));
          setLoader(false);
        } else {
          if (toaster.current) toaster.current.error(data.message);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
      });
  }

  function getVisitNotesList(
    templateField = "title",
    templateSortBy = "DESC",
    search = "",
    page = "1"
  ) {
    const params = {
      sort_by: templateField,
      order: templateSortBy,
      search: search,
      page: page,
      service_id: selectedServiceId
    };

    setVisitNoteLoader(true);
    StaticPageServices.visitNoteTemplatelist(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          setVisitNotesTblData([...data.data.rows]);
          setPages(Math.ceil(data.data.count / TABLE.LIMIT));
          setVisitNoteLoader(false);
        } else {
          if (toaster.current) toaster.current.error(data.message);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
      });
  }

  return (
    <div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> Page List
            </div>
            <div className="mr-10">
              <input
                value={searchText}
                onChange={e => {
                  setSearchText(e.target.value);
                  const search = e.target.value;
                  setLoader(true);
                  setActivePage(0);
                  setTimeout(() => {
                    getList(field, sortBy, search, 1);
                  }, 500);
                }}
                type="text"
                placeholder="Search..."
                className="fs-14 medium-text plr-10 form-control react-form-input"
              />
            </div>
            {/* <div>
               <Button
                className="c-btn c-primary ma-5"
                onClick={() => formAction("add")}
              >
                <i className="fas fa-plus mr-10" />
                Add Content
              </Button>
            </div> */}
          </div>
          <div className="roe-card-body">
            <ReactTable
              style={{
                border: "none",
                boxShadow: "none"
              }}
              data={tblData}
              columns={columns}
              defaultPageSize={10}
              minRows={2}
              manual
              defaultFilterMethod={(filter, row) => {
                const id = filter.pivotId || filter.id;

                return row[id] !== undefined
                  ? String(row[id].toLowerCase()).includes(
                      filter.value.toLowerCase()
                    )
                  : true;
              }}
              className="-striped -highlight custom-react-table-theme-class"
              pages={pages}
              page={activePage}
              PaginationComponent={Pagination}
              loading={loader}
              LoadingComponent={Loader}
              onFetchData={onChangePageGetData}
              onPageChange={pageIndex => {
                setActivePage(pageIndex);
                getList(field, sortBy, searchText, pageIndex + 1);
              }}
              onSortedChange={sortProperties => {
                const sort = sortProperties[0].desc ? "DESC" : "ASC";
                setSortBy(sort);
                setActivePage(0);
                setField(sortProperties[0].id);
                getList(sortProperties[0].id, sort, searchText, 1);
                // alert("sort handler", sortProperties);
                // const orderByDirection = sortProperties[0].desc ? 1 : 0;

                // updateMapStateInfoOrderByColumn(sortProperties[0].id, orderByDirection);
              }}
            />
          </div>
          {/* <CommonModel
            modal={modal}
            toggle={toggle}
            children={
              view ? (
                <DeleteModal deleteHandler={deleteHandler} toggle={toggle} />
              ) : (
                ""
              )
            } */}
        </div>
      </div>
      {hasAccess(
        MODULE_NAMES.VISIT_NOTE_TEMPLATE,
        PERMISSION_TYPE.VIEW,
        permissions
      ) && (
        <div className="plr-15">
          <div className="roe-card-style mtb-15">
            <div className="roe-card-header module-header">
              <div className="flex-1 fs-16 demi-bold-text">
                <span className="hash"># </span> Visit Notes
              </div>
              <div className="fs-14 mr-10">
                <Dropdown
                  isOpen={serviceDropdownOpen}
                  toggle={toggleServiceDropdown}
                >
                  <DropdownToggle caret size="md">
                    {selectedServiceName}
                  </DropdownToggle>
                  <DropdownMenu
                    modifiers={{
                      setMaxHeight: {
                        enabled: true,
                        order: 890,
                        fn: data => {
                          return {
                            ...data,
                            styles: {
                              ...data.styles,
                              overflow: "auto",
                              maxHeight: "300px"
                            }
                          };
                        }
                      }
                    }}
                  >
                    <DropdownItem
                      onClick={() => {
                        setSelectedServiceId(null);
                        setSelectedServiceName("All Services");
                      }}
                    >
                      All Services
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setSelectedServiceId(SERVICE_TYPE.NUTRITION);
                        setSelectedServiceName(
                          SERVICE_NAME[SERVICE_TYPE.NUTRITION]
                        );
                      }}
                    >
                      {SERVICE_NAME[SERVICE_TYPE.NUTRITION]}
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        setSelectedServiceId(SERVICE_TYPE.MENTAL_HEALTH);
                        setSelectedServiceName(
                          SERVICE_NAME[SERVICE_TYPE.MENTAL_HEALTH]
                        );
                      }}
                    >
                      {SERVICE_NAME[SERVICE_TYPE.MENTAL_HEALTH]}
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
              <div className="mr-10">
                <input
                  value={searchTemplateText}
                  onChange={e => {
                    setSearchTemplateText(e.target.value);
                    const search = e.target.value;
                    setVisitNoteLoader(true);
                    setActivePage(0);
                    setTimeout(() => {
                      getVisitNotesList(
                        templateField,
                        templateSortBy,
                        search,
                        1
                      );
                    }, 500);
                  }}
                  type="text"
                  placeholder="Search..."
                  className="fs-14 medium-text plr-10 form-control react-form-input"
                />
              </div>
              {hasAccess(
                MODULE_NAMES.VISIT_NOTE_TEMPLATE,
                PERMISSION_TYPE.ADD,
                permissions
              ) && (
                <div>
                  <Button
                    className="c-btn c-primary ma-5"
                    onClick={() => formActionForNotes("add")}
                  >
                    <i className="fas fa-plus mr-10" />
                    Add
                  </Button>
                </div>
              )}
            </div>
            <div className="roe-card-body">
              <ReactTable
                style={{
                  border: "none",
                  boxShadow: "none"
                }}
                data={visitNotesTblData}
                columns={visitNotesColumn}
                defaultPageSize={10}
                minRows={2}
                manual
                defaultFilterMethod={(filter, row) => {
                  const id = filter.pivotId || filter.id;

                  return row[id] !== undefined
                    ? String(row[id].toLowerCase()).includes(
                        filter.value.toLowerCase()
                      )
                    : true;
                }}
                className="-striped -highlight custom-react-table-theme-class"
                pages={pages}
                page={activePage}
                PaginationComponent={Pagination}
                loading={visitNoteLoader}
                LoadingComponent={Loader}
                onFetchData={onChangePageGetData}
                onPageChange={pageIndex => {
                  setActivePage(pageIndex);
                  getVisitNotesList(
                    templateField,
                    templateSortBy,
                    searchTemplateText,
                    pageIndex + 1
                  );
                }}
                onSortedChange={sortProperties => {
                  const sort = sortProperties[0].desc ? "ASC" : "DESC";
                  setTemplateSortBy(sort);
                  setActivePage(0);
                  setTemplateField(sortProperties[0].id);
                  getVisitNotesList(
                    sortProperties[0].id,
                    sort,
                    searchTemplateText,
                    1
                  );
                }}
              />
            </div>
            <CommonModel
              modal={modal}
              toggle={toggle}
              children={
                <DeleteModal
                  text={"Are you sure you want to delete this template?"}
                  deleteHandler={deleteHandler}
                  toggle={toggle}
                />
              }
            />
          </div>
        </div>
      )}
      <Toaster ref={toaster} />
    </div>
  );
};

export default withRouter(StaticPageTable);
